import type { ReactNode } from "react";
import { createContext, useMemo } from "react";

interface DataContextProps {
  data: any;
  children: ReactNode;
}

export const DataContext = createContext<DataContextProps | null>(null);

export const DataContextProvider = ({ data, children }: DataContextProps) => {
  const dataContextProviderValue = useMemo(() => (data), [data]);
  return <DataContext.Provider value={dataContextProviderValue}>{children}</DataContext.Provider>
};
